/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum ConditionValue {
  MoreThan = 'MORE_THAN',
  LessThan = 'LESS_THAN',
  MoreOrLessThan = 'MORE_OR_LESS_THAN'
}
